export function getFileExtension(filename: string): string {
   // Split the filename by dot and get the last part
   const parts = filename.split(".");
   // If there's no dot or the filename starts with a dot and has no extension, return empty string
   if (parts.length < 2 || (parts[0] === "" && parts.length === 2)) {
      return "";
   }
   // Return the last part, which should be the extension
   return parts.pop() || "";
}


/**
 * Splits a filename into name, extension, and the index of the dot separating them.
 *
 * @param {string} filename - The full name of the file.
 * @returns { {name: string, extension: string, dotIndex: number} }
 * An object containing the separated name, extension, and the index of the dot (-1 if no extension).
 */
export function splitFilename(filename: string): { name: string; extension: string; dotIndex: number } {
   if (!filename) filename = '';
   const dotIndex = filename.lastIndexOf('.');
   if (dotIndex === -1) {
      return { name: filename, extension: '', dotIndex: -1 };
   } else {
      const name = filename.substring(0, dotIndex);
      const extension = filename.substring(dotIndex + 1);
      return { name, extension, dotIndex };
   }
}

/**
 * ตรวจสอบว่า number เป็น index ที่ถูกต้องของ Array หรือไม่
 * หากระบุ array มา ก็จะตรวจสอบว่า number เป็น index ที่อยู่ในขอบเขตของ array ด้วยหรือไม่
 * หากไม่ระบุ array มา จะตรวจสอบเพียงแค่ว่าเป็นจำนวนเต็มบวกหรือไม่
 * 
 * Checks if a given number is a valid index.
 * If an array is provided, ensures the number is within its bounds.
 * Otherwise, only checks if the number is a non-negative integer.
 * 
 * @param {number} number - The index to check.
 * @param {Array} [arr] - Optional array to validate the index against.
 * @returns {boolean} - Returns `true` if the index is valid, otherwise `false`.
 */
export function isValidArrayIndex(number: number, array?: unknown[]): boolean {
   if (!Number.isInteger(number) || number < 0) {
       return false; // เป็นจำนวนเต็มบวกหรือไม่
   }
   if (array !== undefined && Array.isArray(array)) {
       return number < array.length; // อยู่ในขอบเขต array หรือไม่
   }
   return true;
}